export const adfSendEvent = (name = '') => (params = {}) => {
    window.adf && window.adf.ClickTrack(window,1495908,name,params);
}